import React, { useRef, useState } from "react";
import { motion } from "framer-motion";
import Tracker from '@openreplay/tracker';
import './styles/App.css';
import './styles/Footer.css';
import './styles/CTAButton.css';
import './styles/MoreInfo.css';
import './styles/FAQ.css'
import './styles/Swiper.css'
import EspoBuiltHeader from "./components/EspoBuiltHeader";
import VtoriBaner from "./web_elements/banner01_hd.webp";
import ImageSlider from "./components/Swiper";
import CentralArrow from "./components/CentralArrow";
import { ReactComponent as Textbox1 } from './web_elements/TextSVG/textbox1_svg-o.svg';
import { ReactComponent as EkipatNiSVG } from './web_elements/TextSVG/textbox2_svg-o.svg';
import { ReactComponent as Textbox3IconsSVG } from './web_elements/TextSVG/texbox3_values_icons_svg-o.svg';
import CallToAction from "./components/CallToAction";
import PurviBaner from './web_elements/nov_purvi_baner_malak.webp';
import SuperBtnImg from './web_elements/SuperBtn.png';
import { ReactComponent as KontaktnaForma } from './web_elements/kontaktna_forma-o.svg'
import BlueDecorativeStripe from "./web_elements/blu_decorative_stripe_full.png";
import DecorativeStripeFull from "./web_elements/decorative_stripe_full.png";
import OshteInformaciq from "./components/OshteInformaciq";
import AnimatedEndLogo from "./components/AnimatedEndLogo";

function App() {
    let tracker = null;
    if (process.env.REACT_APP_DEBUG_MODE === "true") {
        console.log("DEBUG: ", process.env.REACT_APP_DEBUG_MODE);
        console.log("Debug mode enabled.")
        tracker = new Tracker({
                projectKey: process.env.REACT_APP_OPENREPLAY_KEY,
                ingestPoint: "https://replay.topmaterial.org/ingest",
                __DISABLE_SECURE_MODE: true,
            }
        );
        Object.keys(process.env)
            .filter(key => key.startsWith('REACT_APP_'))
            .forEach(key => {
                console.log(`${key}: ${process.env[key]}`);
            });
        console.log("DEBUG TRACKER: ", tracker);
    }
    else{
        tracker = new Tracker({
                projectKey: process.env.REACT_APP_OPENREPLAY_KEY,
                ingestPoint: "https://replay.topmaterial.org/ingest",
                //__DISABLE_SECURE_MODE: true,
            }
        );
        console.log("DEBUG TRACKER: ", tracker);
    }
    tracker.start()
        .then(() => {
            console.log("Tracker started!");
        })
        .catch((err) => {
            console.error("Tracker failed to start:", err);
        });

    const pageStartRef = useRef(null);
    const zaNasRef = useRef(null);
    const uslugiRef = useRef(null);
    const ourValues = useRef(null);
    const kontaktnaFormaRef = useRef(null);
    const callToActionRef = useRef(null);
    const ourFAQRef = useRef(null);
    //const [isHovered, setIsHovered] = useState(false);

    const handlePageStartScroll = () => {
        pageStartRef.current.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
    };

    const handleZaNasScroll = () => {
        zaNasRef.current.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
    };


    const handleUslugiScroll = () => {
        uslugiRef.current.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
    };

    const handleOurValuesScroll = () => {
        ourValues.current.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
    };

    const handleOurFAQScroll = () => {
        ourFAQRef.current.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
    };

    const handleKontaktnaFormaScroll = () => {
        kontaktnaFormaRef.current.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
    };

    const handleCallToActionScroll = () => {
        setTimeout(() => {
            callToActionRef.current.scrollIntoView({ behavior: "smooth", block:"center", inline: "nearest" });
        }, 200); // Delay to allow initial scrollIntoView to complete
    };
    setTimeout(() => {
        window.scrollBy({
            top: -window.innerHeight * 0.5, // Scroll 20% of the viewport height up
            behavior: "smooth",
        });
    }, 1000); // Delay to allow initial scrollIntoView to complete
    const phoneNumber = "+359876452875"; // Replace with your phone number
    const emailAddress = "espobuilt@gmail.com"; // Replace with your email
  return (
      <div className="App">
          <header style={{
              position: "sticky",
              top: 0,
              zIndex: 10000
          }}>
            <EspoBuiltHeader />
          </header>
          <body>
          <div>
              <div id="discount-banner">
                  <img
                      src={PurviBaner}
                      style={{position: "relative"}}
                      alt="">
                  </img>
              </div>
          </div>

          <div id="otvedi-me-div" ref={pageStartRef} onClick={handleKontaktnaFormaScroll}>
              <motion.div
                  whileTap={{scale: 0.5, duration: 0.8}}
              >
                  <img
                      id="otvedi-me-img"
                      src={SuperBtnImg}
                      alt="">
                  </img>
              </motion.div>
          </div>
          <div ref={zaNasRef}>
              <Textbox1 id="textbox-1"/>
          </div>
          <img className="vtori-baner"
               style={{
                   position: "relative",
                   zIndex: 2001
               }}
               src={VtoriBaner}
               alt="">
          </img>

          <EkipatNiSVG ref={uslugiRef} id="ekipat-ni"/>
          <div>
              <ImageSlider/>
          </div>
          <OshteInformaciq />
          <img id="decorative-stripe-full"
               src={DecorativeStripeFull}
               alt="">
          </img>

          <Textbox3IconsSVG ref={ourValues} id="our-values"/>
          <div ref={ourFAQRef} id="central-arrow-container">
              <CentralArrow/>
          </div>
          <KontaktnaForma ref={kontaktnaFormaRef} style={{
              width: "60%",
              height: "auto",
          }}/>
          <div ref={callToActionRef}>
              <CallToAction/>
          </div>
          <div id="footer">
              <p className="contact" id="kontakti">Контакти:</p>
              <a href="tel:+359876452875" id="telefon">+359876452875<span id="phone-text-only-footer"> - Управител - Запитвания</span></a><br></br>
              <span id="email-text-only-footer">Имейл</span><a href="mailto:espobuilt@gmail.com"
                                                               className="link-contact"> espobuilt@gmail.com</a>
              <p id="rabotno-vreme" className="contact">Работно време:</p>
              <p id="grafik-na-vreme" className="contact">Понеделник - Събота<br></br>08:00 - 18:00 </p>
              <p onClick={handlePageStartScroll} id="nachalo-link" className="contact">Начало</p>
              <p onClick={handleZaNasScroll} className="contact">За нас</p>
              <p onClick={handleUslugiScroll} className="contact">Услуги</p>
              <p onClick={handleOurValuesScroll} className="contact">Нашите ценности</p>
              <p onClick={handleOurFAQScroll} className="contact">ЧЗВ</p>
              <p onClick={handleCallToActionScroll} className="contact">Контакти</p>
              <p id="trademark" className="contact">2025 ESPO Built. Всички права запазени.</p>
              <img id="blue-stripe-full"
                   src={BlueDecorativeStripe}
                   alt="">
              </img>
              <AnimatedEndLogo id="animated-logo" />
          </div>
          </body>
      </div>
  );
}

export default App;